import { GroupRoles } from "@/schemas/group-member";

const GroupMemberQueryKeys = {
  global: ["groupMembers"] as const,

  list: (groupId: string) => ["group", groupId, "members"] as const,
  groupMemberWithoutSearch: (groupId: string, role: GroupRoles) =>
    ["group", groupId, "members", role] as const,
  groupMember: (groupId: string, role: GroupRoles, q: string) =>
    ["group", groupId, "members", role, q] as const,
};

export { GroupMemberQueryKeys };
